import { BounceContainer } from '@components/BounceContainer/BounceContainer'
import { Stack, Typography } from '@mui/material'
import React from 'react'
import { IconType } from 'react-icons'
import { useNavigate } from 'react-router-dom'

export interface IActionButtonProps {
  onClick?: () => void
  route?: string
  color: string
  icon: IconType
  label: string
}

export const ActionButton = ({ onClick, route, color, icon: Icon, label }: IActionButtonProps) => {
  const navigate = useNavigate()

  const handleOnClick = () => {
    if (onClick) {
      onClick()
    } else if (route) {
      navigate(route)
    }
  }

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      mt={0.5}
      color={(theme) => theme.palette.text.secondary}
      sx={{ '&:hover': { color: '#cfcfcf' } }}
    >
      <Stack
        onClick={handleOnClick}
        justifyContent="center"
        alignItems="center"
        color={(theme) => theme.palette.text.secondary}
        sx={{
          cursor: 'pointer',
          '&:hover': { backgroundColor: 'rgba(240, 240, 255, 0.1)' },
        }}
        height={54}
        width={54}
        borderRadius={25}
        bgcolor="rgba(240, 240, 255, 0.06)"
      >
        <BounceContainer>
          <Stack justifyContent="center" alignItems="center">
            <Icon size={25} color={color} style={{ marginTop: 0 }} />
          </Stack>
        </BounceContainer>
      </Stack>
      <Typography mt={0.1} fontSize={13}>
        {label}
      </Typography>
    </Stack>
  )
}
